import { useEffect } from "react";

import { useSalesContext } from "../../../../sales-context/SalesContext";
import { useLanguageStore } from "./useLanguageStore";

/**
 * Seeds the language selection from the task locale once per session (e.g. an `es-mx` task starts in
 * Spanish). The expert can still override afterward via {@link LanguageSelector}; re-seeding when the
 * session changes also overwrites any value persisted from a previous call, so the language never
 * leaks across sessions. Call once, high in the sale-flow tree.
 */
export function useInitDisclosureLanguage(): void {
    const { sessionId, taskData } = useSalesContext();
    const locale = taskData.locale;

    useEffect(() => {
        useLanguageStore.getState().updateLanguage(locale);
    }, [sessionId, locale]);
}
